module.exports = __webpack_public_path__ + "static/media/IXh.4654ba19.png";